var Feedback = /** @class */ (function () {
    function Feedback($el) {
        this.$el = jQuery($el);
        this.init();
    }
    Feedback.prototype.init = function () {
        var $box = this.$el;
        $box.find('#feedback-choice a.no').click(function (e) {
            e.preventDefault();
            $box.find('#feedback-choice').slideUp();
            $box.find('#feedback-support').slideDown();
        });
        $box.find('#feedback-choice a.yes').click(function (e) {
            e.preventDefault();
            $box.find('#feedback-choice').slideUp();
            $box.find('#feedback-rate').slideDown();
        });
    };
    ;
    return Feedback;
}());
export default Feedback;
